/* eslint-disable max-lines */
import create from 'zustand'

import { saveRegistrationDocument } from '@Requests'

import { tracks } from '../../constants/tracks'
import constants from './constants'
import getRegisterId from './get-register-id'
import { UseDocsType, SendFilesType } from './interface'

const { ERROR_MESSAGE } = constants

// @ts-ignore
const useDocs = create<UseDocsType>((set, get) => ({
  businessName: '',
  businessStatus: '',
  registerId: getRegisterId(),
  loading: false,
  businessRegistrationTexts: [],
  personRegistrationTexts: [],
  filterRegistrationDocs(registrationTexts) {
    const businessDocs = registrationTexts?.filter(
      (item) => item?.documentType === 'BUSINESS'
    )
    const personDocs = registrationTexts?.filter(
      (item) => item?.documentType === 'PERSON'
    )
    set({
      businessRegistrationTexts: businessDocs,
      personRegistrationTexts: personDocs,
    })
  },
  error: '',
  success: '',
  setBusinessName(name: string) {
    set({ businessName: name })
  },
  setBusinessStatus(status: string) {
    set({ businessStatus: status })
  },
  setBusinessRegistrationTexts(registrationTexts) {
    set({ businessRegistrationTexts: registrationTexts })
  },
  setPersonRegistrationTexts(registrationTexts) {
    set({ personRegistrationTexts: registrationTexts })
  },
  maxFilesMessage() {
    const { setError, setSuccess } = get()
    setSuccess('')
    setError(ERROR_MESSAGE.MAX_FILES)
    mixpanel.track(tracks.ERROR_QTD_MAX_FILES)
  },
  maxSizeMessage() {
    const { setError, setSuccess } = get()
    setSuccess('')
    setError(ERROR_MESSAGE.MAX_SIZE)
    mixpanel.track(tracks.ERROR_FILE_MAX_SIZE)
  },
  rejectMessage() {
    const { setError, setSuccess, businessRegistrationTexts } = get()
    setSuccess('')
    setError(ERROR_MESSAGE.SERVER(businessRegistrationTexts?.length))
    mixpanel.track(tracks.ERROR_NOT_ATTACH_DOCS)
  },
  setLoading(loading: boolean) {
    set({ loading })
  },
  setError(error: string) {
    set({ error })
  },
  setSuccess(success: string) {
    const { setError } = get()
    setError('')
    set({ success: '' })
    setTimeout(() => set({ success }))
  },
  getHasDocs() {
    const { businessRegistrationTexts } = get()
    return (
      businessRegistrationTexts?.length &&
      businessRegistrationTexts?.every(
        (item) => (item?.files || [])?.length > 0
      )
    )
  },
  getDocsFormData(file, requestedDocumentId) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('requestedDocumentId', requestedDocumentId)
    return formData
  },
  async saveAllFiles() {
    const { registerId, getDocsFormData, businessRegistrationTexts } = get()
    const allPromises = businessRegistrationTexts?.flatMap((item) =>
      item?.files?.map((file: File) => {
        const formData = getDocsFormData(file, item?.pendingDocumentId || '')
        return saveRegistrationDocument(registerId, formData)
      })
    )

    return await Promise.all(allPromises)
  },
  async sendFiles({ onSuccess, onError }: SendFilesType) {
    const {
      saveAllFiles,
      setLoading,
      setError,
      setSuccess,
      getHasDocs,
      businessRegistrationTexts,
    } = get()

    try {
      if (!getHasDocs()) return
      setLoading(true)
      setError('')
      setSuccess('')
      await saveAllFiles()
      onSuccess()
    } catch {
      setError(ERROR_MESSAGE.SERVER(businessRegistrationTexts?.length))
      onError()
    } finally {
      setLoading(false)
    }
  },
  updateRegistrationDocs(files, index) {
    const { businessRegistrationTexts } = get()
    businessRegistrationTexts[index] = {
      ...businessRegistrationTexts?.[index],
      files,
    }
    set({ businessRegistrationTexts })
  },
}))

export default useDocs
